var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { SendOutlined } from '@ant-design/icons';
import { Button, TextArea } from 'ui/styled';
import { RED, WHITE } from 'ui/constants';
import { AGENT_PARTY_TYPE, selectChatMessages, useChatStore } from 'stores/nic/stores/chatStore';
import { useNicService } from 'stores/nic/useNicService';
import { getTimeFormat } from 'utils/helpers/dateHelper';
import { ChatHeader, ChatWrapper, EmptyMessages, MessageBubble, MessageInputWrapper, MessageItem, MessageMeta, MessagesList, SkillName } from './styled';
var ChatDialog = function (_a) {
    var contactId = _a.contactId, skillName = _a.skillName;
    var _b = useState(''), text = _b[0], setText = _b[1];
    var _c = useState(false), isSending = _c[0], setIsSending = _c[1];
    var _d = useState(false), isEnding = _d[0], setIsEnding = _d[1];
    var messages = useChatStore(selectChatMessages);
    var _e = useNicService(), endChat = _e.endChat, sendChatMessage = _e.sendChatMessage;
    var listRef = useRef(null);
    useEffect(function () {
        if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        }
    }, [messages]);
    var handleSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var message, isSent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = text.trim();
                    if (!message || isSending)
                        return [2 /*return*/];
                    setIsSending(true);
                    return [4 /*yield*/, sendChatMessage(contactId, message)];
                case 1:
                    isSent = _a.sent();
                    if (isSent)
                        setText('');
                    setIsSending(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEnd = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsEnding(true);
                    return [4 /*yield*/, endChat(contactId)];
                case 1:
                    _a.sent();
                    setIsEnding(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(ChatWrapper, { "data-test": "nicChatDialog", children: [_jsxs(ChatHeader, { children: [_jsx(SkillName, { children: skillName ? "Skill: ".concat(skillName) : 'Chat' }), _jsx(Button, { btntype: "custom", btnsize: "custom", bgcolor: RED, color: WHITE, border: "none", padding: "4px 16px", loading: isEnding, onClick: handleEnd, children: "End" })] }), _jsx(MessagesList, { ref: listRef, children: messages.length ? (messages.map(function (item) {
                    var isAgent = item.PartyType === AGENT_PARTY_TYPE;
                    return (_jsxs(MessageItem, { "$isAgent": isAgent, children: [_jsx(MessageBubble, { "$isAgent": isAgent, children: item.Text }), _jsxs(MessageMeta, { children: [isAgent ? 'You' : item.Label || item.PartyType, " \u00B7", ' ', getTimeFormat(item.TimeStamp)] })] }, "".concat(item.TimeStamp, "-").concat(item.PartyType, "-").concat(item.Text)));
                })) : (_jsx(EmptyMessages, { children: "No messages yet" })) }), _jsxs(MessageInputWrapper, { children: [_jsx(TextArea, { value: text, onChange: function (e) {
                            return setText(e.target.value);
                        }, onPressEnter: function (e) {
                            if (e.shiftKey)
                                return;
                            e.preventDefault();
                            handleSend();
                        }, placeholder: "Type a message", autoSize: { minRows: 1, maxRows: 4 }, disabled: isEnding }), _jsx(Button, { type: "primary", icon: _jsx(SendOutlined, {}), loading: isSending, disabled: !text.trim() || isEnding, onClick: handleSend })] })] }));
};
export default ChatDialog;
